import React from 'react';
import Lottie from 'lottie-react';
import rocketAnimation from '../../assets/lotties/rocket.json'; // adjust path as needed

interface BoostRocketProps {
    width: number;
    height: number;
}


const BoostRocket= ({ width = 200, height = 200 }: BoostRocketProps) => {
    return (
        <div style={{ width, height }}>
            <Lottie
                animationData={rocketAnimation}
                loop={true}
                autoplay={true}
                style={{ width: '100%', height: '100%' }}
            />
        </div>
    );
};

export default BoostRocket;
